/**
 * Shapes shared between the streaming services and the UI watching them. Kept
 * free of imports so a component can name a service without pulling the
 * Spotify and Tidal services (and the store behind them) along with it.
 */

export type StreamingServiceId = 'spotify' | 'apple' | 'tidal';

export const SERVICE_NAMES: Record<StreamingServiceId, string> = {
  spotify: 'Spotify',
  apple: 'Apple Music',
  tidal: 'Tidal',
};

export type StreamingExportPhase =
  | 'matching'
  | 'creating'
  | 'adding'
  | 'done'
  | 'error';

export interface StreamingExportTrack {
  artist: string;
  title: string;
}

export interface StreamingExportProgress {
  service: StreamingServiceId;
  playlistName: string;
  phase: StreamingExportPhase;
  matched: number;
  total: number;
  currentTrack: string;
  message: string;
}
